import { NJText } from "@engie-group/fluid-design-system-react";
import { SkillCompatibilityBrandIcon } from "./SkillCompatibilityBrandIcon";

/** A row of harness pills, each showing its brand logo + label. */
export function SkillCompatibilityTags({
  items,
  max,
  emptyLabel = "None",
}: {
  items: string[];
  max?: number;
  emptyLabel?: string;
}) {
  const shown = max ? items.slice(0, max) : items;
  if (shown.length === 0) {
    return (
      <NJText as="span" scale="xs" className="text-nj-neutral-tertiary-default">
        {emptyLabel}
      </NJText>
    );
  }
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {shown.map((value) => (
        <span
          key={value}
          className="inline-flex items-center gap-1 rounded-full border border-nj-brand-subtle-default bg-nj-brand-secondary-default px-2 py-0.5"
        >
          <SkillCompatibilityBrandIcon value={value} />
          <NJText as="span" scale="xs" className="text-nj-brand-solid-default">
            {value}
          </NJText>
        </span>
      ))}
    </div>
  );
}
